import { render, staticRenderFns } from "./StickersPage.vue?vue&type=template&id=2d0d30d0&"
import script from "./StickersPage.vue?vue&type=script&lang=js&"
export * from "./StickersPage.vue?vue&type=script&lang=js&"
import style0 from "./StickersPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports